const VISIBILITY_PERSENTAGE = 70;

export const isElementInViewport = (node: HTMLDivElement | null): boolean => {
    if (!node) {
        return false;
    }

    const { bottom, height, left, right, top, width } = node.getBoundingClientRect();
    /* istanbul ignore next */
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;
    /* istanbul ignore next */
    const windowWidth = window.innerWidth || document.documentElement.clientWidth;

    const isVisibleVertically =
        Math.floor(100 + ((top >= 0 ? 0 : top) / height) * 100) >= VISIBILITY_PERSENTAGE &&
        Math.floor(100 - ((bottom - windowHeight) / height) * 100) >= VISIBILITY_PERSENTAGE;

    const isVisibleHorizontally =
        Math.floor(100 + ((left >= 0 ? 0 : left) / width) * 100) >= VISIBILITY_PERSENTAGE &&
        Math.floor(100 - ((right - windowWidth) / width) * 100) >= VISIBILITY_PERSENTAGE;

    return isVisibleVertically && isVisibleHorizontally;
};
